module.exports = __webpack_public_path__ + "static/media/balkaPGP.17258864.jpg";